export default "__VITE_ASSET__Ccweyx2Y__"